import React from 'react';

function PartialScoresNavbar(props) {
    return (
        <div className="scores-navbar">
            {props.scores.slice(1).map(score => {
                return (
                    <div key={score.p}>
                        <span className="desc">{score.p}</span>
                        <span className="score">{score.s1} - {score.s2}</span>
                    </div>
                )
            })}
        </div>
    );
}

export default PartialScoresNavbar;